export default __webpack_public_path__ + "static/media/financialSolutions.3c26589a.png";